module.exports = __webpack_public_path__ + "img/5-5.35a06d99.svg";